module.exports = __webpack_public_path__ + "static/media/readtronicFooter.32f65bd5.svg";